<template>
    <div class="AI container">
        <ReAiNavigate/>
        <router-link to="/data/ai/prompts/0" class="btn btn-primary">Добавить</router-link>
        <REAIPrompt v-for="p in ApiData" :key="p.id" :prompt="p"/>
    </div>
</template>

<script>
import ReAiNavigate from './ReAiNavigate.vue';
import REAIPrompt from './REAIPrompt.vue';

    export default {
        name: 'AI',
        components: {
            REAIPrompt,
            ReAiNavigate,
        },
        props: {
            
        }, 
        
        data() {
            return {
                ApiData:[],
            }
        },
        computed:{
        },
        methods: {
            async load(){
                let result = await this.$GVO.Api.AI.prompts_get({});
                if(result.success===true){
                    this.ApiData= result.data;
                }
            },
        },
        mounted() {
            this.load();
        }
    };
</script>

<style scoped lang="scss">
</style>
